import { useNavigate } from "react-router";
import { useState } from "react";
import { DISCOVER_REGIONAL_SPOTLIGHT } from "../../../constants/routes";
import { useMarketSpotlightPageLayout } from "../../../hooks/api/v2/marketSpotlightLayout/useMarketSpotlightPageLayout";
import { SpotlightListCollection } from "./SpotlightListCollection";

export const SpotlightListCollectionRegional = () => {
  const marketSpotlightPageLayoutQuery = useMarketSpotlightPageLayout({
    type: "regional",
  });

  const pageIds = marketSpotlightPageLayoutQuery.data?.pageIds;

  if (!pageIds?.length) return null;

  return <RegionalSpotlights pageIds={pageIds} />;
};

const RegionalSpotlights = ({ pageIds }: { pageIds: string[] }) => {
  const navigate = useNavigate();
  const [randomisedPageIds] = useState(() =>
    pageIds.toSorted(() => Math.random() - 0.5),
  );

  return (
    <SpotlightListCollection
      title={"Regional spotlights"}
      pageIds={randomisedPageIds}
      type={"regional"}
      onClick={() => navigate(DISCOVER_REGIONAL_SPOTLIGHT)}
    />
  );
};
